export const FETCH_ALL_HEALTH_PARTNER = 'fetch_all_health_partner';
export const FETCH_ALL_HEALTH_PARTNER_SUCCESS = 'fetch_all_health_partner_success';
export const EDIT_HEALTH_PARTNER = 'edit_health_partner';
export const DELETE_HEALTH_PARTNER = 'delete_health_partner';
export const CREATE_HEALTH_PARTNER = 'create_health_partner';
export const CREATE_HEALTH_PARTNER_SUCCESS = 'create_health_partner_success';
export const UPDATE_HEALTH_PARTNER_SUCCESS = 'update_health_partner_success';
export const UPDATE_HEALTH_PARTNER = 'update_health_partner';
export const DELETE_HEALTH_PARTNER_SUCCESS = 'delete_health_partner_success';
export const SET_HEALTH_PARTNER = 'set_health_partner';